import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getAgents } from "actions/agents";
import AgentsTable from "components/Tables/AgentsTable";

export const Agents = () => {
  const location = useLocation();
  const agents = useSelector((state) => state.agents.agents);
  const dispatch = useDispatch();
  const [retrievedAgents, setRetrievedAgents] = useState(false);

  useEffect(() => {
    if (agents.length === 0 && !retrievedAgents) {
      setRetrievedAgents(true);
      dispatch(getAgents());
    }
  }, [agents, retrievedAgents, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  return (
    <div>
      <AgentsTable agents={agents} />
    </div>
  );
};

export default Agents;
